import { Observable } from 'rxjs';
import { IsNavigationInProgressService } from './services/is-navigation-in-progress.service';

export function createIsNavigationInProgressTrigger(
  navigationInProgressService: IsNavigationInProgressService,
): Observable<boolean> {
  return navigationInProgressService.isNavigationInProgress$;
}
